import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useTypedSelector } from '../../../../../hooks';
import { getAppliedDiscount } from '../../../ducks';
import { TermsPrice } from './TermsPrice';
import { IconSmile } from '../../../../../brenger-shared-ui';
import cn from 'classnames';
import { getIsExcludingVat } from '../../../../User/ducks';

export const TermsBlockTotalPrice = (): JSX.Element => {
  const price = useTypedSelector(state => state.generalTransport.quote?.price);
  const isLoading = useTypedSelector(state => state.generalTransport.price.isLoading);
  const discount = useTypedSelector(getAppliedDiscount);
  const isExlcVat = useTypedSelector(getIsExcludingVat);
  return (
    <h3
      className={cn('flex justify-between pt-[1em] text-primary font-bold order-overview--total', {
        'order-overview--total--discounted': !!discount,
      })}
    >
      <div className="flex">
        <Translate id={discount ? 'request_flow.price.total_after_discount' : 'request_flow.terms.price_total'} />
        {isExlcVat && (
          <>
            {' '}
            (<Translate id={'request_flow.price.ex_vat'} />)
          </>
        )}
      </div>
      {isLoading && (
        <div style={{ marginLeft: 'auto', marginRight: '0.5em', fontSize: '0.6em' }}>
          <IconSmile spinning={true} />
        </div>
      )}
      <TermsPrice price={price} addPlusMinusIndicator={false} isLoading={isLoading} />
    </h3>
  );
};
